const getEnv = (env: string | undefined) => {
  const val = env && env;
  return val;
};

const homePageTitle: string = getEnv(process.env.GATSBY_HOME_PAGE_TITLE) ?? '';
const homePageTitleShort: string =
  getEnv(process.env.GATSBY_HOME_PAGE_TITLE_SHORT) ?? '';
const siteTitle: string = getEnv(process.env.GATSBY_SITE_TITLE) ?? '';
export { homePageTitle, siteTitle, homePageTitleShort };
